import { KycReviewDocumentType } from '__generated__/GQL';
import { OBUserContext } from 'features/Bento/types/OBContext';

import { HOST_ID_DOCUMENT_TYPES, IdType } from './constants';

const ID_TYPES = Object.keys(HOST_ID_DOCUMENT_TYPES) as IdType[];

/**
  A function returning the id type corresponding to a document type
 */
const getIdType = (docType: KycReviewDocumentType): IdType | undefined =>
  ID_TYPES.find((docId) => HOST_ID_DOCUMENT_TYPES[docId].includes(docType));

/**
  A function returning the first id type matching one of the documents
 */
export const getInitialIdType = (
  kycDocuments: OBUserContext['kycDocuments'],
): IdType | undefined =>
  kycDocuments
    .map((doc) => getIdType(doc.type))
    .find((type) => type !== undefined);
